// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Wx62k"};